module.exports = __webpack_public_path__ + "img/t4-events.3763ac1c.png";